/* eslint-disable no-plusplus */
/**
 * Created by ivancai on 2019/5/13.
 * 此工具类请放置一些常用操作函数，如字符操作，存取cookie等
 */
import axios from 'axios';
import baseUrl from '@/configs/baseUrl';

export default {
  getCookie(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim();
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
  },
  getQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  setCookie(cname, cvalue, d) {
    // const d = new Date();
    // d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toGMTString()}`;
    document.cookie = `${cname}=${cvalue}; ${expires}`;
  },
  downloadFile(url, params = {}, withToken = true, needBaseUrl = true) {
    const token = this.getCookie('X-Access-Token');
    const headers = withToken ? { 'X-Access-Token': token } : {};
    url = needBaseUrl ? `${baseUrl}${url}` : url;
    return axios({
      url,
      method: 'GET',
      params,
      responseType: 'blob',
      headers
    });
  },
  downloadBlobFile(blob, filename) {
    let objUrl;
    if (typeof blob == 'object') {
      objUrl = window.URL.createObjectURL(blob);
    } else if (blob.indexOf('http') !== -1) {
      objUrl = blob;
    } else {
      objUrl = window.URL.createObjectURL(blob);
    }
    const a = document.createElement('a');
    if ('download' in a) {
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = objUrl;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(objUrl);
      document.body.removeChild(a);
      return;
    }
    // IE
    navigator.msSaveBlob(blob, filename);
  },
  base64ToBlob(dataurl) {

    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime
    });
  },
  blobToDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = function (e) {
      callback(e.target.result);
    };
    a.readAsDataURL(blob);
  },
  isPoneAvailable($poneInput) {
    var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
    if (!myreg.test($poneInput)) {
      return false;
    } else {
      return true;
    }
  },
  // 格式化时间
  dateFtt(fmt, date) { //author: meizz 
    var o = {
      "M+": date.getMonth() + 1,     //月份 
      "d+": date.getDate(),     //日 
      "h+": date.getHours(),     //小时 
      "m+": date.getMinutes(),     //分 
      "s+": date.getSeconds(),     //秒 
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
      "S": date.getMilliseconds()    //毫秒 
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },
  // 创建时间格式化显示
  currentTime(fmt) {
    var crtTime = new Date();
    return this.dateFtt(fmt || "yyyy-MM-dd hh:mm:ss", crtTime);//直接调用公共JS里面的时间类处理的办法  
  },
  getBase64ToImgFile(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.addEventListener('load', function () {
        // 监听load后返回的数据
        resolve(reader.result)
      })
      if (file) {
        reader.readAsDataURL(file);
      }
    })
  },
  dayAgodate(day) { // 几天前日期
    var today = new Date();
    var time = (today).getTime() - (day || 7) * 24 * 60 * 60 * 1000;
    var tragetTime = new Date(time);
    return [tragetTime, today];
  },
  verificationImgUpload(file) {
    const isImg = file.type == "image/jpeg" || file.type == "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isImg) {
      window.vm.$message.error("上传图片只能是 JPG 或 PNG 格式!");
    }
    if (!isLt2M) {
      window.vm.$message.error("上传图片大小不能超过 2MB!");
    }
    return isImg && isLt2M;
  },
  verificationVideoUpload(file) {
    const isVideo = file.type == "video/webm" || file.type == "video/ogg" || file.type == "video/3gp" || file.type == "video/mp4";
    if (!isVideo) {
      window.vm.$message.error("上传视频 mp4, webm, ogg, 3gp");
    }
    return isVideo;
  },
  formatter(params) {
    let newParamsName = ""; // 最终拼接成的字符串
    let paramsNameNumber = params.length; // 实际标签的个数
    let provideNumber = 6; // 每行能显示的字的个数
    let rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
    /**
     * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
     */
    // 条件等同于rowNumber>1
    if (paramsNameNumber > provideNumber) {
      /** 循环每一行,p表示行 */
      for (let p = 0; p < rowNumber; p++) {
        let tempStr = ""; // 表示每一次截取的字符串
        let start = p * provideNumber; // 开始截取的位置
        let end = start + provideNumber; // 结束截取的位置
        // 此处特殊处理最后一行的索引值
        if (p === rowNumber - 1) {
          // 最后一次不换行
          tempStr = params.substring(start, paramsNameNumber);
        } else {
          // 每一次拼接字符串并换行
          tempStr = params.substring(start, end) + "\n";
        }
        newParamsName += tempStr; // 最终拼成的字符串
      }
    } else {
      // 将旧标签的值赋给新标签
      newParamsName = params;
    }
    return newParamsName;
  },
  copyToClipboard(text) {
    // if (text.indexOf('-') !== -1) {
    //     let arr = text.split('-');
    //     text = arr[0] + arr[1];
    // }
    var textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? '成功复制到剪贴板' : '该浏览器不支持点击复制到剪贴板';
        return successful;
    } catch (err) {
        return false
    }
  },
  parseToMoney(num) {
    num = parseFloat(num.toFixed(3));
    let [integer, decimal] = String.prototype.split.call(num, '.');
    integer = integer.replace(/\d(?=(\d{3})+$)/g, '$&,');
    return integer + (decimal ? ('.' + decimal) : '');
  }
};